import { render, staticRenderFns } from "./abstrRegistAuthorTab.vue?vue&type=template&id=13fddc9f&"
import script from "./abstrRegistAuthorTab.vue?vue&type=script&lang=js&"
export * from "./abstrRegistAuthorTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports